import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { 
  Menu, 
  // Tooltip
} from 'antd';
import PropTypes from 'prop-types';
import { getReportBuilderAuth } from 'Actions/User'
import { appRoutes } from 'Config/route';
import { DecodeCurrentUser } from 'Helpers';
import { NEW_INSIGHT_LINK } from 'Config/constants';
import { DownOutlined } from '@ant-design/icons';
import Badge from '../Badge';

export const menuList = [
  {
    key: 'headcount',
    title: 'Headcount',
    link: appRoutes.HEADCOUNT_SCREEN,
    isShow: false,
    submenu: [
      {
        key: 'subheadcount',
        title: 'Headcount',
        link: appRoutes.HEADCOUNT_SCREEN,
        isNew: false,
        isExternal: false,
        target: '',
        isShow: false
      },
      {
        key: 'new_active',
        title: 'New & active',
        link: NEW_INSIGHT_LINK.newActive,
        isNew: true,
        isExternal: true,
        target: '',
        isShow: false
      },
      {
        key: 'turnover',
        title: 'Turnover',
        link: NEW_INSIGHT_LINK.turnover,
        isNew: true,
        isExternal: true,
        target: '',
        isShow: false
      }
    ]
  },
  {
    key: 'time_management',
    title: 'Time Management',
    link: appRoutes.ATTENDANCE_SCREEN,
    isShow: false,
    submenu: [
      {
        key: 'attendance',
        title: 'Attendance',
        link: appRoutes.ATTENDANCE_SCREEN,
        isNew: false,
        isExternal: false,
        target: '',
        isShow: false
      },
      {
        key: 'attendance_new',
        title: 'Attendance',
        link: NEW_INSIGHT_LINK.attendance,
        isNew: true,
        isExternal: true,
        target: '',
        isShow: false
      },
      {
        key: 'overtime',
        title: 'Overtime',
        link: NEW_INSIGHT_LINK.overtime,
        isNew: false,
        isExternal: true,
        target: '',
        isShow: false
      }
    ]
  },
  {
    key: 'payroll',
    title: 'Payroll',
    link: NEW_INSIGHT_LINK.payroll,
    isExternal: true,
    isShow: false,
    submenu: []
  },
  {
    key: 'employee_risk',
    title: 'Employee At Risk',
    link: NEW_INSIGHT_LINK.employeeAtRisk,
    isExternal: true,
    isShow: false,
    isNew: true,
    submenu: []
  },
  {
    key: 'employee_performance',
    title: 'Employee Performance',
    link: NEW_INSIGHT_LINK.performance,
    isExternal: true,
    isShow: false,
    submenu: []
  },
  {
    key: 'insight_plus',
    title: 'Insight+',
    link: appRoutes.CUSTOM_DASHBOARD,
    isShow: false,
    isNew: true,
    submenu: [
      {
        key: 'subheadcount',
        title: 'Custom dashboard',
        link: appRoutes.CUSTOM_DASHBOARD,
        isNew: false,
        isExternal: false,
        target: '',
        isShow: false
      },
      {
        key: 'turnover',
        title: 'Basic report builder',
        link: NEW_INSIGHT_LINK.reportBuilder,
        isNew: false,
        isExternal: true,
        isShow: false
      }
    ]
  }
];

function MenuWrap(props) {
  const { location } = props;
  const dispatch = useDispatch();
  const reportBuilderAuth = useSelector((state) => state.reportBuilderAuth);

  useEffect(() => {
    dispatch(getReportBuilderAuth('report_builder'));
  }, [dispatch]);

  // Move the access menu logic inside the component
  const currentMenuList = useMemo(() => {
    const accessMenu = JSON.parse(DecodeCurrentUser())?.current_user?.access_menu;
    
    if (!accessMenu) {
      return menuList;
    }

    const isMenuAvaiable = (key) => {
      if (Object.values(accessMenu).includes(key)) {
        return accessMenu[key];
      }
      return true;
    };

    return menuList.map((menu) => {
      const updatedMenu = { ...menu };
      updatedMenu.isShow = isMenuAvaiable(menu.key);

      updatedMenu.submenu = menu.submenu.map((sub) => {
        const updatedSub = { ...sub };
        updatedSub.isShow = isMenuAvaiable(sub.key);

        // Hide report builder based on API response
        if (menu.key === 'insight_plus' && sub.key === 'turnover') {
          updatedSub.isShow = reportBuilderAuth.data?.msg === 'ok';
        }

        return updatedSub;
      });

      return updatedMenu;
    });
  }, [reportBuilderAuth.data]);

  // const payrollTooltipMsg = (
  //   <span>
  //     The available data on the chart is from January 2023. The data from the
  //     previous year is in the process of migration.
  //   </span>
  // );

  return (
    <Menu mode="horizontal" selectedKeys={[location.pathname]}>
      {currentMenuList
        .filter((e) => e.isShow)
        .map((menu) => {
          if (menu?.submenu.length) {
            return (
              <Menu.SubMenu
                key={menu.key}
                title={
                  <>
                    {menu.title}&nbsp;
                    <DownOutlined />
                  </>
                }
              >
                {menu.submenu
                  .filter((e) => e.isShow)
                  .map((submenu) => {
                    return (
                      <Menu.Item key={submenu.link}>
                        {!submenu.isExternal ? (
                          <Link to={submenu.link}>{submenu.title}</Link>
                        ) : (
                          <a href={submenu.link} target={submenu.target}>
                            {submenu.title}
                            {submenu.isNew && <Badge setText="New" />}
                          </a>
                        )}
                      </Menu.Item>
                    );
                  })}
              </Menu.SubMenu>
            );
          }

          return (
            <Menu.Item key={menu.link} className="menuItem" data-testid="menu">
              {/* {menu.title === 'Payroll' ? (
                <Tooltip placement="bottomLeft" title={payrollTooltipMsg}>
                  <Link to={appRoutes.PAYROLL_SCREEN}>Payroll</Link>
                </Tooltip>
              ) : ( */}
              <>
                {!menu.isExternal ? (
                  <>
                    <Link to={menu.link}>{menu.title}</Link>
                    {menu.isNew && <Badge setText="New" />}
                  </>
                ) : (
                  <a href={menu.link} target={menu.target}>
                    {menu.title}
                    {menu.isNew && <Badge setText="New" />}
                  </a>
                )}
              </>
              {/* )} */}
            </Menu.Item>
          );
        })}
    </Menu>
  );
}

MenuWrap.propTypes = {
  location: PropTypes.object.isRequired
};

export default withRouter(MenuWrap);
